module.exports = __webpack_public_path__ + "static/media/index.296b54fb.less";